var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"data-test":"emoji"}},[_c(_vm.icon,{tag:"component",attrs:{"width":24,"height":24}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }